import{a as e}from"./chunk-AP2OU4L5.js";import{m as a}from"./chunk-HBP5N4FR.js";a();var h=()=>{let n=window==null?void 0:window.location.search,t=new URLSearchParams(n),r=Object.fromEntries(t),s=r==null?void 0:r.address;return e(s)?s:null};export{h as a};
//# sourceMappingURL=chunk-IQDF3AEY.js.map
